import { ChangeDetectionStrategy, Component, DestroyRef, inject, input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { TranslatePipe } from '@ngx-translate/core';

import { GanLucidIcon } from '@gan/shared/ui-icon';

import { DarkModeTogglerService } from '../../services/dark-mode-toggler.service';

@Component({
  selector: 'gan-dark-mode-toggler',
  templateUrl: './dark-mode-toggler.component.html',
  styleUrls: ['./dark-mode-toggler.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [GanLucidIcon, TranslatePipe]
})
export class DarkModeTogglerComponent implements OnInit {
  private readonly darkModeTogglerService = inject(DarkModeTogglerService);
  private readonly destroyRef = inject(DestroyRef);

  readonly showLabel = input(false);
  toggleControl = new FormControl<boolean>(false, { nonNullable: true });

  ngOnInit(): void {
    this.toggleControl.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(darkMode => {
      this.darkModeTogglerService.toggleTheme(darkMode);
    });

    this.toggleControl.setValue(this.darkModeTogglerService.isDarkMode$.getValue());
  }
}
